import ProfilePic from '../../images/user/profile-img.png';
import { getPaginatedResult } from "../utils/ComponentUtil";


class PaymentProofAPI {
    static payments = [
        {
            name: 'JOHN SNOW',
            profilePic: ProfilePic,
            email: 'dwaynejohn@gmail.com',
            phone: '8563210502',
            amount: '₹ 65,000'
        },
        {
            name: 'JAIME LANISTER',
            profilePic: ProfilePic,
            email: 'jaimelanister@gmail.com',
            phone: '8563210502',
            amount: '₹ 1,25,000'
        },
        {
            name: 'ARYA STARC',
            profilePic: ProfilePic,
            email: 'aryastarc@gmail.com',
            phone: '8563210502',
            amount: '65,000'
        },
        {
            name: 'JOHN SNOW',
            profilePic: ProfilePic,
            email: 'dwaynejohn@gmail.com',
            phone: '8563210502',
            amount: '₹ 65,000'
        },
        {
            name: 'JAIME LANISTER',
            profilePic: ProfilePic,
            email: 'jaimelanister@gmail.com',
            phone: '8563210502',
            amount: '₹ 1,25,000'
        },
        {
            name: 'ARYA STARC',
            profilePic: ProfilePic,
            email: 'aryastarc@gmail.com',
            phone: '8563210502',
            amount: '65,000'
        },
        {
            name: 'JOHN SNOW',
            profilePic: ProfilePic,
            email: 'dwaynejohn@gmail.com',
            phone: '8563210502',
            amount: '₹ 65,000'
        },
        {
            name: 'JAIME LANISTER',
            profilePic: ProfilePic,
            email: 'jaimelanister@gmail.com',
            phone: '8563210502',
            amount: '₹ 1,25,000'
        },
        {
            name: 'ARYA STARC',
            profilePic: ProfilePic,
            email: 'aryastarc@gmail.com',
            phone: '8563210502',
            amount: '65,000'
        },
        {
            name: 'JAIME LANISTER',
            profilePic: ProfilePic,
            email: 'jaimelanister@gmail.com',
            phone: '8563210502',
            amount: '₹ 1,25,000'
        },
        {
            name: 'ARYA STARC',
            profilePic: ProfilePic,
            email: 'aryastarc@gmail.com',
            phone: '8563210502',
            amount: '65,000'
        },
        {
            name: 'JOHN SNOW',
            profilePic: ProfilePic,
            email: 'dwaynejohn@gmail.com',
            phone: '8563210502',
            amount: '₹ 65,000'
        },
        {
            name: 'JAIME LANISTER',
            profilePic: ProfilePic,
            email: 'jaimelanister@gmail.com',
            phone: '8563210502',
            amount: '₹ 1,25,000'
        },
        {
            name: 'ARYA STARC',
            profilePic: ProfilePic,
            email: 'aryastarc@gmail.com',
            phone: '8563210502',
            amount: '65,000'
        },
        {
            name: 'JAIME LANISTER',
            profilePic: ProfilePic,
            email: 'jaimelanister@gmail.com',
            phone: '8563210502',
            amount: '₹ 1,25,000'
        },
        {
            name: 'ARYA STARC',
            profilePic: ProfilePic,
            email: 'aryastarc@gmail.com',
            phone: '8563210502',
            amount: '65,000'
        },
        {
            name: 'JOHN SNOW',
            profilePic: ProfilePic,
            email: 'dwaynejohn@gmail.com',
            phone: '8563210502',
            amount: '₹ 65,000'
        },
        {
            name: 'JAIME LANISTER',
            profilePic: ProfilePic,
            email: 'jaimelanister@gmail.com',
            phone: '8563210502',
            amount: '₹ 1,25,000'
        },
    ];

    static fetchProofs = (page, searchInput) => {
        //change this api calling logic with actual API
        return getPaginatedResult(page, this.payments, 9);
    }
}
export default PaymentProofAPI;